import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, Card, Table, Dropdown, Pagination } from '@themesberg/react-bootstrap';
import { useHistory } from 'react-router-dom';
import { eventShowReducerTypes, storeTypes } from 'types';
import { useDispatch, useSelector } from 'react-redux';
import { faEdit, faEye, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { convertDate, simpleEncrypt } from '../../utils/helpers';
import { eventSingleShowSaga } from '../../reduxToolkit/actions';

export const EventTables = ({ dispatchEvents }: { dispatchEvents: any }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { eventShowState } = useSelector((state: storeTypes.IStore) => state);
    const { data, total, current_page, last_page, to, isLoading } = eventShowState;

    // eslint-disable-next-line no-shadow
    const TableRow = ({ data, index }: { data: eventShowReducerTypes.IEventData; index: number }) => {
        return (
            <tr>
                <td>
                    <span className="fw-normal">{index + 1}</span>
                </td>

                <td>
                    <span className="fw-normal">{data?.title}</span>
                </td>
                <td>
                    <span className="fw-normal">{convertDate(data?.created_at, 'DD-MM-YYYY hh:mm A')}</span>
                </td>

                <td>
                    <Dropdown.Item onClick={() => history.push(`/events/${simpleEncrypt(data?.id)}/view`)}>
                        <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => history.push(`/events/${simpleEncrypt(data?.id)}/update`)}>
                        <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
                    </Dropdown.Item>

                    <Dropdown.Item
                        className="text-danger"
                        onClick={() => {
                            const dispatchPayload = {
                                eventId: data?.id,
                                type: 'delete',
                            };
                            dispatch(eventSingleShowSaga(dispatchPayload));
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
                    </Dropdown.Item>
                </td>
            </tr>
        );
    };

    return (
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
            <Card.Body className="pt-0">
                <Table hover className="user-table align-items-center">
                    <thead>
                        <tr>
                            <th className="border-bottom">#</th>
                            <th className="border-bottom">Title</th>
                            <th className="border-bottom">Created At</th>
                            <th className="border-bottom">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading && (
                            <tr>
                                <td align="center" colSpan={7}>
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {!isLoading &&
                            data.map((eventData: eventShowReducerTypes.IEventData, index: number) => {
                                return <TableRow data={eventData} index={index} key={`transaction-${eventData.id}`} />;
                            })}
                    </tbody>
                </Table>
                <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
                    <Nav>
                        <Pagination className="mb-2 mb-lg-0">
                            <Pagination.Prev
                                onClick={() => dispatchEvents(current_page - 1, '')}
                                disabled={current_page === 1}
                            >
                                Previous
                            </Pagination.Prev>

                            {new Array(last_page).fill(null).map((p, i) => {
                                return (
                                    <Pagination.Item
                                        active={current_page === i + 1}
                                        onClick={() => dispatchEvents(i + 1, '')}
                                    >
                                        {i + 1}
                                    </Pagination.Item>
                                );
                            })}

                            <Pagination.Next
                                onClick={() => dispatchEvents(current_page + 1, '')}
                                disabled={current_page === last_page}
                            >
                                Next
                            </Pagination.Next>
                        </Pagination>
                    </Nav>
                    <small className="fw-bold">
                        Showing <b>{to}</b> out of <b>{total}</b> entries
                    </small>
                </Card.Footer>
            </Card.Body>
        </Card>
    );
};
